// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductView_root__qQxPF","content":"ProductView_content__JrD8x","carousels":"ProductView_carousels__830bR","modals":"ProductView_modals__zKAeQ"};